import React, { useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { FormComponent, LoginWithProvider } from "../components/FormComponents";
import { useUnifiedUser } from "../context/UserContext";
import { IoLogoApple } from "react-icons/io5";
import { isIOS, isMacOs } from "react-device-detect";
import { signIn, signInWithApple, signInWithGoogle } from "../firebase/authservice";
import CircularProgress from "@mui/material/CircularProgress";
import { Card } from "@mui/material";

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { user } = useUnifiedUser();

  const handleLogin = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (!email || !password) return; // Prevent login if fields are empty
    setLoading(true);
    try {
      await signIn(email, password);
      console.log("Login successful");
      console.log("User data", user);
    } catch (error) {
      console.error("Login failed", error);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const user = await signInWithGoogle();
      console.log("Google login successful", user);
    } catch (error) {
      console.error("Google login failed", error);
    }
  };

  const handleAppleLogin = async () => {
    try {
      const user = await signInWithApple();
      console.log("Apple login successful", user);
    } catch (error) {
      console.error("Apple login failed", error);
    }
  };

  return (
     <main className="flex items-center justify-center min-h-screen p-4 min-w-full tablet:flex-col w-screen max-w-[100vw] flex-row gap-0 tablet:gap-14">
      <div className="flex-col w-fit items-center py-6  bg-[white] min-w-[80vw] rounded-xl p-8 shadow-lg">
        <div className="flex-col gap-6 px-[20%] tablet:px-[25%] mobile:px-[5%] w-full text-start">
          <div className="flex-col items-start">
            <h6 className="font-bold">Log in to your account</h6>
          </div>

          <form className="flex-col w-full gap-5 mt-4">
            <FormComponent
              label="Email"
              placeholder="john.doe@example.com"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <FormComponent
              hasForgotPassword
              label="Password"
              placeholder="••••••••"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              className="bg-primary text-white w-full hover:bg-primary/85 transition-colors duration-150 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed p-3 rounded-lg"
              onClick={handleLogin}
              disabled={!email || !password || loading}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
            </button>
          </form>

          <div className="flex items-center [&_hr]:text-txtSecondary/40 gap-4 w-full">
            <hr className="flex-[4]" />
            <p className="text-sm"> OR </p>
            <hr className="flex-[4]" />
          </div>
          <div className="flex gap-3 tablet:flex-col w-full">
            <LoginWithProvider
              onClick={handleGoogleLogin}
              provider="Google"
              icon={<FcGoogle />}
            />
            {(isIOS || isMacOs) && (
              <LoginWithProvider
                onClick={handleAppleLogin}
                provider="Apple"
                icon={<IoLogoApple />}
              />
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default LoginPage;
